import React from "react";
import { useRouteMatch } from "react-router-dom";
import { NavBar } from "../../components/NavBar";

import content from "./content/content.json";

export const NavBarContainer: React.FC = () => {
  const { path } = useRouteMatch();

  return <NavBar menu={content.navbarConfig} nav={content.navbarAccountConfig} currentPath={path} />;
};
